// Configure Monaco Editor to use bundled version instead of CDN
// This file MUST be imported before any other code that uses Monaco
import { loader } from "@monaco-editor/react";
import * as monaco from "monaco-editor";
// eslint-disable-next-line import/default
import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
// eslint-disable-next-line import/default
import jsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";

// Setup Monaco Environment for workers
(self as any).MonacoEnvironment = {
  getWorker(_: any, label: string) {
    if (label === "json") {
      return new jsonWorker();
    }
    return new editorWorker();
  },
};

// Make Monaco immediately available globally
(window as any).monaco = monaco;

// Configure @monaco-editor/react loader to use our bundled Monaco
loader.config({ monaco });

// Override loader.config to prevent CDN reconfiguration by web components
const originalLoaderConfig = loader.config.bind(loader);
const originalLoaderInit = loader.init.bind(loader);

loader.config = function (config: any) {
  if (config && config.paths) {
    console.warn("[Monaco] Blocked CDN path config");
    return;
  }
  if (config && config.monaco) {
    return originalLoaderConfig(config);
  }
  // Default: use our monaco
  return originalLoaderConfig({ monaco });
};

loader.init = function () {
  // eslint-disable-next-line no-console
  console.log("[Monaco] Using bundled version");
  return originalLoaderInit();
};

// Pre-initialize Monaco so it's ready for web components
loader.init().then(() => {
  // eslint-disable-next-line no-console
  console.log("[Monaco] Ready (bundled)");
});
